// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"228":"96eb8ce9","247":"15fcb32a","274":"30505b18","358":"9e4c6c0e","443":"fa34f211","519":"28d42e8c","546":"f8095296","759":"52ac018e","924":"4ee165e6","966":"c2464bbd"}[chunkId] + ".css";
};